<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import IcfModal from "./components/icf-modal.vue";
import RpcppeModal from "./components/rpcppe-modal.vue";
import PropertyBySearch from "./components/property-by-search.vue";
import PropertyCart from "./components/property-cart.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Employee from "@/components/modals/employee-hris.vue";
import Location from "@/components/modals/property-location.vue";
import FundCluster from "@/components/modals/fund-cluster-list.vue";
import ItemCategory from "@/components/modals/item-category.vue";
import PropertyUpdate from "@/components/modals/property-create.vue";
import Supplier from "@/components/modals/supplier.vue";
import Unit from "@/components/modals/unit.vue";

export default {
    page: {
        title: "Properties"
    },
    components: {
        Layout,
        PageHeader,
        IcfModal,
        RpcppeModal,
        PrintOptions,
        DatePicker,
        MaskedInput,
        Employee,
        Location,
        FundCluster,
        ItemCategory,
        PropertyBySearch,
        PropertyUpdate,
        Supplier,
        Unit,
        PropertyCart,
    },
    data() {
        return {
            title: "Properties",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/"
                },
                {
                    text: "Properties",
                    active: true
                }
            ],
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true
            }),
            searchData: {
                poNumber: '',
                propertyNumber: '',
                propertyName: '',
                employeeIdNumber: '',
                employeeName: '',
                parIcsNumber: '',
                locationId: 0,
                locationName: '',
                fundClusterId: 0,
                fundClusterName: '',
                itemCategoryId: 0,
                itemCategoryName: '',
                year: null,
                minCost: '',
                maxCost: '',
            },
            getByValue: 1,
            bySearchData: [],
            byAllData: [],
            bySearchBusy: false,
            employeeData: null,
            selectedProperties: [],
            propertyindex: -1,
            poIndex: -1,
            fcType: 'search',
            itemCatType: 'search',
            mouseOverCart: false,
        }
    },
    computed: {
        compareCost() {
            if (parseFloat(this.getExactAmt(this.searchData.minCost)) > parseFloat(this.getExactAmt(this.searchData.maxCost))){
                return 1;
            } 
            if(this.getExactAmt(this.searchData.minCost) != "" && this.getExactAmt(this.searchData.maxCost) == ""){
                return 1;
            }
            return 0;
        },
    },
    created() {
        this.changeCampus(this.$store.state.data.selectedCampus.id);
        this.getMyCart();
    },
    methods: {
        async changeCampus(campusId) {
            this.getByValue = 1;
            this.resetSearchData();
            await this.wait(100);
            this.getBySearch();
        },
        resetSearchData() {
            this.searchData = {
                poNumber: '',
                propertyNumber: '',
                propertyName: '',
                employeeIdNumber: '',
                employeeName: '',
                parIcsNumber: '',
                locationId: 0,
                locationName: '',
                fundClusterId: 0,
                fundClusterName: '',
                itemCategoryId: 0,
                itemCategoryName: '',
                year: new Date(`01-01-${this.$store.state.data.cycle}`),
                minCost: '',
                maxCost: '',
            }
        },
        async getMyCart(){
            try{
                const { data: response } = await this.$store.dispatch("propertycart/GetMyCart");
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.map(item => {
                    item.name = item.propertyName;
                })
                this.selectedProperties = response;
            }catch{
                this.showToast("Something went wrong - Getting cart items!", "error");
            }
        },
        getIcf(){
            this.$bvModal.show("icf-modal");
        },
        getPpe(){
            this.$bvModal.show("rpcppe-modal");
        },
        printIcf(){
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/ICF/Campus`,
                routeVariables: [this.$store.state.data.selectedCampus.id]
            });
            this.$bvModal.show("print-options-modal");
        },
        printIcfEmployee(data, type = 0){
            var apiUrl = ``;
            if(data.printOpts == 2 || type == 1){
                apiUrl = `api/Report/Property/ICF`;
            }else if(data.printOpts == 5 || type == 2){
                apiUrl = `api/Report/Property/ICF/HighValue`;
            }else if(data.printOpts == 6 || type == 3){
                apiUrl = `api/Report/Property/ICF/LowValue`;
            }else if(data.printOpts == 3){
                apiUrl = `api/Report/Property/ICF/All`;
            }
            this.$refs.printOpt.putOptions({
                apiUrl: apiUrl,
                routeVariables: [data.id]
            });
            this.$bvModal.show("print-options-modal");
        },
        printIcfLocation(data){
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/ICF/Location`,
                routeVariables: [this.$store.state.data.selectedCampus.id],
                body: [data.id]
            });
            this.$bvModal.show("print-options-modal");
        },
        printRpcppeEmployee(data){
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/Inventory/PPE`,
                routeVariables: [data.id]
            });
            this.$bvModal.show("print-options-modal");
        },
        printEmpProperties() {
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/Employee/All/Campus`,
                routeVariables: [this.$store.state.data.selectedCampus.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async searchQuery(data){
            try{
                const { data: response } = await this.$store.dispatch("property/GetPropertybySearch", data);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.map((item) => {
                    item.visible = false;
                    item.itemVisible = false;
                    item.assignmentHistory = [];
                    item.assignVisible = false;
                    item.assignLoading = false;
                    item.inventory = [];
                    item.inventoryVisible = false;
                    item.inventoryLoading = false;
                    item.inspectionVisible = false;
                    item.attachmentVisible = false;
                    item.attachmentLoading = false;
                    item.addDocu = false;
                    item.fileSearch = "";
                    item.propertyInspections.map((inspect) => {
                        inspect.inspectionFiles = [];
                        inspect.attachmentLoading = false;
                    });
                    item.filterKey = `${item.poNumber} ${item.supplier} ${item.name} ${item.propertyNumber} ${item.serialNumber} ${item.currentAssignment ? item.currentAssignment.assignmentNumber : ''}`;
                });
                this.bySearchData = response;
            }catch(e){
                this.showToast("Something went wrong!", "error");
            }
        },
        async getBySearch(){
            this.bySearchBusy = true;
            window.scrollTo(0, 0);
            let data = JSON.parse(JSON.stringify(this.searchData));
            if (this.getExactAmt(this.searchData.minCost) != null && this.getExactAmt(this.searchData.minCost) != "") {
                data.minCost = this.getExactAmt(this.searchData.minCost);
            } else {
                data.minCost = 0;
            }
            if (this.getExactAmt(this.searchData.maxCost) != null && this.getExactAmt(this.searchData.maxCost) != "") {
                data.maxCost = this.getExactAmt(this.searchData.maxCost);
            } else {
                data.maxCost = 0;
            }
            if (this.searchData.year != null && this.searchData.year != "") {
                data.year = this.searchData.year.getFullYear();
            }
            data.campusId = this.$store.state.data.selectedCampus.id;
            data.removeLoading = true;
            await this.searchQuery(data);
            this.bySearchBusy = false;
            if(data.employeeIdNumber){
                this.getEmployeeInfo(data.employeeIdNumber);
            }
        },
        async getEmployeeInfo(idNo){
            try{
                const { data: response } = await this.$store.dispatch("externalemployee/GetByEmployeeId", idNo.trim());
                if(response.error){
                    this.employeeData = null;
                }
                this.employeeData = response;
            }catch(e){
                this.employeeData = null;
            }
        },
        getLocation(data) {
            this.$refs.location.getData(this.$store.state.data.selectedCampus.id);
            this.$bvModal.show("property-location");
        },
        dropLocation(data){
            this.searchData.locationId = data.location.id;
            this.searchData.locationName = data.location.location;
            this.getBySearch();
        },
        removeLocation(){
            this.searchData.locationId = 0;
            this.searchData.locationName = '';
            if(this.bySearchData.length > 0){
                this.getBySearch();
            }
        },
        getEmployee() {
            this.$refs.employee.resetData();
            this.$bvModal.show("property-employee");
        },
        dropEmployee(data) {
            this.searchData.employeeIdNumber = data.idNo;
            this.searchData.employeeName = `${data.firstName} ${data.lastName}`;
            this.$bvModal.hide("property-employee");
        },
        removeEmployee(){
            this.searchData.employeeIdNumber = '';
            this.searchData.employeeName = '';
            if(this.bySearchData.length > 0){
                this.getBySearch();
            }
        },
        getFundCluster(type) {
            this.fcType = type;
            this.$refs.fundcluster.getData();
            this.$bvModal.show("property-fund-cluster");
        },
        dropFundCluster(data) {
            if(this.fcType == 'search'){
                this.searchData.fundClusterId = data.id;
                this.searchData.fundClusterName = data.cluster;
            }else{
                this.$refs.propertyupdate.dropFundCluster(data);
            }
        },
        removeFundCluster(type){
            this.searchData.fundClusterId = 0;
            this.searchData.fundClusterName = '';
        },
        getItemCategory(type) {
            this.itemCatType = type;
            this.$refs.itemcategory.filterPropertyCategory();
            this.$bvModal.show("property-item-category");
        },
        dropItemCat(data) {
            if(this.itemCatType == 'search'){
                this.searchData.itemCategoryId = data.id;
                this.searchData.itemCategoryName = data.name;
            }else{                
                this.$refs.propertyupdate.dropItemCat(data);
            }
        },
        removeItemCat(){
            this.searchData.itemCategoryId = 0;
            this.searchData.itemCategoryName = '';
        },
        getSupplier() {
            this.$bvModal.show("supplier-modal");
        },
        dropSupplier(data) {
            this.$refs.propertyupdate.dropSupplier(data);
        },
        getUnit() {
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.$refs.propertyupdate.dropUnit(data);
        },
        addToCart(row) {
            this.selectedProperties.push(row);
            this.addCartProperties(row);
        },
        async addCartProperties(row) {
            try{
                const { data:response } = await this.$store.dispatch("propertycart/AddToCart", [{id: row.id}]);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
            }catch(err){
                this.showToast("Error saving to cart!", "error");
                return;
            }
        },
        async removeFromMyCart(row) {
            try{
                const { data:response } = await this.$store.dispatch("propertycart/RemoveFromCart", row.id);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
            }catch(err){
                this.showToast("Error removing from cart!", "error");
                return;
            }
        },
        removeFromCart(row) {
            var index = this.selectedProperties.findIndex((x) => x.id == row.id);
            this.selectedProperties.splice(index, 1);
            this.removeFromMyCart(row);
            if (this.selectedProperties.length == 0) {
                this.$bvModal.hide("modal-cart");
            }
        },
        printPar(rows){
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/PAR`,
                routeVariables: [],
                body: rows
            });
            this.$bvModal.show("print-options-modal");
        },
        printIcs(rows){
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/ICS`,
                routeVariables: [],
                body: rows
            });
            this.$bvModal.show("print-options-modal");
        },
        printSticker(id){
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/Property/Sticker/Property`,
                routeVariables: [id]
            });
            this.$bvModal.show("print-options-modal");
        },
        printPropertyCard(propertyId){
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/Property/Card`,
                routeVariables: [propertyId],
                body: { propertyId }
            });
            this.$bvModal.show("print-options-modal");
        },
        updateItem({props, po}) {
            if (this.getByValue == 1) {
                this.propertyindex = this.bySearchData.findIndex((item) => item.id == props.id);
            } else {
                this.poIndex = this.byAllData.findIndex((item) => item.poNumber == po.poNumber);
                this.propertyindex = this.byAllData[this.poIndex].details.findIndex((item) => item.id == props.id);
            }
            this.$refs.propertyupdate.updateProperty(props.id);
        },
        onUpdateItem(props) {
            props.visible = false;
            props.itemVisible = false;
            props.assignmentHistory = [];
            props.assignVisible = false;
            props.assignLoading = false;
            props.inventory = [];
            props.inventoryVisible = false;
            props.inventoryLoading = false;
            props.inspectionVisible = false;
            props.attachmentVisible = false;
            props.attachmentLoading = false;
            props.addDocu = false;
            props.fileSearch = "";
            props.propertyInspections.forEach((inspect) => {
                inspect.inspectionFiles = [];
                inspect.attachmentLoading = false;
            });
            if (this.getByValue == 1) {
                this.bySearchData.splice(this.propertyindex, 1, props);
            } else {
                this.byAllData[this.poIndex].details.splice(this.propertyindex, 1, props);
            }
        },
        printICSByEmployee({poNumber, id}) {
            if(!poNumber || poNumber.toLowerCase() == "not indicated" || poNumber == '.'){
                this.showToast("Selected property/ies does not have a PO number.", "warning");
                return;
            }
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/ICS/PO/AccountableOfficer`,
                routeVariables: [poNumber, id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printICSByPo(poNumber){
            if(!poNumber || poNumber.toLowerCase() == "not indicated" || poNumber == '.'){
                this.showToast("Selected property/ies does not have a PO number.", "warning");
                return;
            }
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/ICS/PO`,
                routeVariables: [poNumber],
            });
            this.$bvModal.show("print-options-modal");
        },
        printPARByEmployee({poNumber, id}) {
            if(!poNumber || poNumber.toLowerCase() == "not indicated" || poNumber == '.'){
                this.showToast("Selected property/ies does not have a PO number.", "warning");
                return;
            }
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/PAR/PO/AccountableOfficer`,
                routeVariables: [poNumber, id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printPARByPo(poNumber){
            if(!poNumber || poNumber.toLowerCase() == "not indicated" || poNumber == '.'){
                this.showToast("Selected property/ies does not have a PO number.", "warning");
                return;
            }
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/PAR/PO`,
                routeVariables: [poNumber],
            });
            this.$bvModal.show("print-options-modal");
        },
        printStickerByPo(poNumber){
            if(!poNumber || poNumber.toLowerCase() == "not indicated" || poNumber == '.'){
                this.showToast("Selected property/ies does not have a PO number.", "warning");
                return;
            }
            this.$refs.printOpt.putOptions({
                apiUrl: `api/Report/Property/Property/Sticker`,
                routeVariables: [poNumber],
            });
            this.$bvModal.show("print-options-modal");
        },
        showCart() {
            this.$bvModal.show("modal-cart");
        },
    }
}
</script>
<template>
    <Layout @changeCampus="changeCampus">
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-3">
                <div class="mb-2" >
                    <b-dropdown 
                        id="dropdown-dropleft" 
                        right 
                        variant="purple btn-sm" 
                        toggle-class="text-decoration-none"
                        menu-class="dropdown-menu-start" 
                        no-caret
                    >
                        <template #button-content>
                            <i class="bx bx-printer me-1"></i>
                            Reports
                        </template>
                        <b-dropdown-item @click="getIcf">Print ICF</b-dropdown-item>
                        <b-dropdown-item @click="getPpe">Print RPCPPE</b-dropdown-item>
                        <b-dropdown-item @click="printEmpProperties">Print Employee with Properties</b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="card border-4 border-top border-start-0 border-end-0 border-primary">
                    <div class="card-body pt-3 pb-3 ps-4 pe-4">
                        <b>Get Properties By</b>
                        <select class="form-select mt-3" v-model="getByValue">
                            <option value="1">Search</option>
                            <option value="2">All Properties</option>
                        </select>
                        <b-collapse :visible="getByValue == 1">
                            <div v-if="getByValue == 1">
                                <hr class="my-3" />
                                <!-- P.O. # -->
                                <div class="mt-2 mb-1">P.O. Number</div>
                                <div id="poNumber" class="position-relative">
                                    <input 
                                        autocomplete="off" 
                                        type="text" 
                                        class="form-control rounded border-light"
                                        placeholder="Input PO Number..." 
                                        v-model="searchData.poNumber" 
                                        v-on:keyup.enter="getBySearch" 
                                    />
                                </div>
                                <!-- Property # -->
                                <div class="mt-2 mb-1">Property Number</div>
                                <div id="propertyNumber" class="position-relative">
                                    <input 
                                        autocomplete="off" 
                                        type="text" 
                                        class="form-control rounded border-light"
                                        placeholder="Input Property Number..." 
                                        v-model="searchData.propertyNumber" 
                                        v-on:keyup.enter="getBySearch" 
                                    />
                                </div>
                                <!-- Property Name -->
                                <div class="mt-2 mb-1">Property Name</div>
                                <div id="propertyName" class="position-relative">
                                    <input 
                                        autocomplete="off" 
                                        type="text" 
                                        class="form-control rounded border-light"
                                        placeholder="Input Property Name..." 
                                        v-model="searchData.propertyName" 
                                        v-on:keyup.enter="getBySearch" 
                                    />
                                </div>
                                <!-- Employee -->
                                <div class="mt-2 mb-1">Employee</div>
                                <b-input-group>
                                    <template #append>
                                        <b-button 
                                            v-if="!searchData.employeeIdNumber" 
                                            @click="getEmployee" 
                                            variant="outline-info">
                                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                                        </b-button>
                                        <b-button 
                                            v-else 
                                            @click="removeEmployee" 
                                            variant="outline-danger" 
                                            title="Remove Employee">
                                            <i class="mdi mdi-close-thick"></i>
                                        </b-button>
                                    </template>
                                    <input 
                                        autocomplete="off" 
                                        type="text" 
                                        disabled 
                                        placeholder="Select Employee..."
                                        class="form-control rounded border-light" 
                                        v-model="searchData.employeeName" 
                                    />
                                </b-input-group>
                                <!-- PAR/ICS -->
                                <div class="mt-2 mb-1">PAR/ICS Number</div>
                                <div id="parIcsNumber" class="position-relative">
                                    <input 
                                        autocomplete="off" 
                                        type="text" 
                                        class="form-control rounded border-light"
                                        placeholder="Input PAR/ICS Number..." 
                                        v-model="searchData.parIcsNumber" 
                                        v-on:keyup.enter="getBySearch" 
                                    />
                                </div>
                                <!-- Location -->
                                <div class="mt-2 mb-1">Location</div>
                                <b-input-group>
                                    <template #append>
                                        <b-button 
                                            v-if="!searchData.locationId" 
                                            @click="getLocation" 
                                            variant="outline-info"
                                        >
                                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                                        </b-button>
                                        <b-button 
                                            v-else 
                                            @click="removeLocation" 
                                            variant="outline-danger"
                                        >
                                            <i class="mdi mdi-close-thick"></i>
                                        </b-button>
                                    </template>
                                    <input 
                                        autocomplete="off" 
                                        type="text" 
                                        disabled 
                                        placeholder="Search Location..."
                                        class="form-control rounded border-light" 
                                        v-model="searchData.locationName" 
                                    />
                                </b-input-group>
                                <!-- Fund Cluster -->
                                <div class="mt-2 mb-1">Fund Cluster</div>
                                <b-input-group>
                                    <template #append>
                                        <b-button 
                                            v-if="!searchData.fundClusterId" 
                                            @click="getFundCluster('search')" 
                                            variant="outline-info"
                                        >
                                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                                        </b-button>
                                        <b-button 
                                            v-else 
                                            @click="removeFundCluster('search')" 
                                            variant="outline-danger"
                                            title="Remove Fund Cluster"
                                        >
                                            <i class="mdi mdi-close-thick"></i>
                                        </b-button>
                                    </template>
                                    <input 
                                        autocomplete="off" 
                                        type="text" 
                                        disabled 
                                        placeholder="Search Fund Cluster..."
                                        class="form-control rounded border-light" 
                                        v-model="searchData.fundClusterName" 
                                    />
                                </b-input-group>
                                <!-- Category -->
                                <div class="mt-2 mb-1">Item Category</div>
                                <b-input-group>
                                    <template #append>
                                        <b-button 
                                            v-if="!searchData.itemCategoryId" 
                                            @click="getItemCategory('search')" 
                                            variant="outline-info"
                                        >
                                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                                        </b-button>
                                        <b-button 
                                            v-else 
                                            @click="removeItemCat('search')" 
                                            variant="outline-danger"
                                            title="Remove Item Category"
                                        >
                                            <i class="mdi mdi-close-thick"></i>
                                        </b-button>
                                    </template>
                                    <input 
                                        autocomplete="off" 
                                        type="text" 
                                        disabled 
                                        placeholder="Search Item Category..."
                                        class="form-control rounded border-light" 
                                        v-model="searchData.itemCategoryName" 
                                    />
                                </b-input-group>
                                <!-- Year -->
                                <div class="mt-2 mb-1">Year</div>
                                <date-picker 
                                    id="year" 
                                    v-model="searchData.year" 
                                    :first-day-of-week="1" 
                                    type="year" 
                                    lang="en"
                                    class="rounded border-light" 
                                    placeholder="Select Year..." 
                                    @change="getBySearch"
                                />
                                <!-- Cost -->
                                <div class="mt-2 mb-1">Cost</div>
                                <div class="d-flex justify-content-between">
                                    <div class="me-3">
                                        <masked-input 
                                            id="minCost" 
                                            type="text" 
                                            v-model="searchData.minCost" 
                                            placeholder="Min Cost..."
                                            class="form-control rounded border-light" 
                                            :class="{ 'is-invalid': compareCost == 1 }" 
                                            autocomplete="off" 
                                            :mask="currencyMask" 
                                            v-on:keyup.enter="getBySearch"
                                        />
                                        <div v-if="compareCost == 1" class="invalid-feedback">
                                            <span v-if="!$v.form.amount.required">This value is required.</span>
                                        </div>
                                    </div>
                                    <div>
                                        <masked-input 
                                            id="maxCost" 
                                            type="text" 
                                            v-model="searchData.maxCost" 
                                            placeholder="Max Cost..."
                                            class="form-control rounded border-light" 
                                            :class="{ 'is-invalid': compareCost == 1 }" 
                                            autocomplete="off" 
                                            :mask="currencyMask" 
                                            v-on:keyup.enter="getBySearch"
                                        />
                                        <div v-if="compareCost == 1" class="invalid-feedback">
                                            <span>Max Cost should be greater than Min Cost.</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- Get -->
                                <hr class="my-3" />
                                <button type="button" @click="getBySearch"
                                    class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mt-3 mb-1">
                                    <i class="bx bx-download fs-6 me-2"></i>Get Properties
                                </button>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <transition name="slide">
                    <template v-if="getByValue == 1">
                        <PropertyBySearch 
                            :tableData="bySearchData" 
                            :busy="bySearchBusy"
                            :employeeData="employeeData"
                            :getByValue="getByValue"
                            :selectedProperties="selectedProperties"
                            @add-to-cart="addToCart"
                            @remove-from-cart="removeFromCart"
                            @print-par="printPar"
                            @print-ics="printIcs"
                            @print-sticker="printSticker"
                            @print-property-card="printPropertyCard"
                            @update-item="updateItem"
                            @print-ics-by-employee="printICSByEmployee"
                            @print-ics-po="printICSByPo"
                            @print-par-by-employee="printPARByEmployee"
                            @print-par-po="printPARByPo"
                            @print-sticker-by-po="printStickerByPo"
                        />
                    </template>
                </transition>
            </div>
        </div>
        <transition name="fade">
            <div 
                v-if="selectedProperties.length" 
                @mouseenter="mouseOverCart = true" 
                @mouseleave="mouseOverCart = false"
                class="position-fixed" 
                style="bottom: 20px; left: 50px"
            >
                <span 
                    class="badge bg-danger rounded-pill position-fixed" 
                    style="bottom: 55px; left: 85px"
                >
                    {{ selectedProperties.length }}
                </span>
                <div title="View Cart" class="avatar-sm mx-auto cursor-pointer" @click="showCart">
                    <span class="avatar-title rounded-circle bg-info">
                        <i 
                            class="mdi mdi-cart-outline font-size-24" 
                            :class="{ 'bx-tada': mouseOverCart == true }"
                        >
                        </i>
                    </span>
                </div>
            </div>
        </transition>
        <IcfModal 
            @printIcf="printIcf" 
            @printIcfEmployee="printIcfEmployee"
            @printIcfLocation="printIcfLocation"
        />
        <RpcppeModal @printRpcppeEmployee="printRpcppeEmployee" />
        <Employee ref="employee" @dropData="dropEmployee($event)" altId="property-employee"></Employee>
        <Location ref="location" @dropData="dropLocation($event)" altId="property-location"></Location>
        <FundCluster ref="fundcluster" @dropData="dropFundCluster($event)" altId="property-fund-cluster"/>
        <ItemCategory ref="itemcategory" @dropData="dropItemCat($event)" altId="property-item-category"/>
        <Supplier @dropData="dropSupplier($event)" />
        <Unit ref="unit" @dropData="dropUnit($event)" />
        <PropertyUpdate 
            ref="propertyupdate" 
            @updateData="onUpdateItem($event)" 
            @getFundCluster="getFundCluster($event)"
            @getItemCategory="getItemCategory($event)" 
            @getSupplier="getSupplier($event)" 
            @getUnit="getUnit($event)"
        />
        <PropertyCart 
            :cartItems="selectedProperties" 
            @remove-from-cart="removeFromCart" 
            @print-par="printPar" 
            @print-ics="printIcs" 
            @print-sticker="printSticker" 
            @print-property-card="printPropertyCard"
        />
        <PrintOptions ref="printOpt" />
    </Layout>
</template>
<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.tooltip {
  opacity: 1 !important;
}

.slide-enter-active {
  animation: slide-in 0.25s;
}

.slide-leave-active {
  animation: slide-in 0.25s reverse;
}

.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-in 0.5s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes slide-in {
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}

.btn.focus,
.btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0 !important;
}
</style>